export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7437.2568d510.jpg";